// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /squares/assignee-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSquaresAssigneeListBody,
  typeSquaresAssigneeListOutput200,
} from "../../sdk/squares/postSquaresAssigneeList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSquaresAssigneeListQueryKey(
  payload: typeSquaresAssigneeListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`gridId:${JSON.stringify(payload.gridId)}`);
  if (typeof payload.searchQuery !== "undefined") {
    queryKeySegments.push(`searchQuery:${JSON.stringify(payload.searchQuery)}`);
  }
  return [
    "post:squares:squaresAssigneeList",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSquaresAssigneeListOutput200,
    unknown,
    typeSquaresAssigneeListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSquaresAssigneeList(
  payload: typeSquaresAssigneeListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSquaresAssigneeListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSquaresAssigneeList(payload),
    ...resolvedOptions,
  });
}
